import React from 'react'
import { useProfileState } from 'context/profile';

function Can({ children, privilege }) {
  const { profile } = useProfileState()

  if (!profile.role?.includes(privilege)) return null
  
  return children
}

export default Can
